/*!
Copyright (C) 2022 Liberty Infrasystems. All rights reserved.
*/

/**
 * A simple function to generate a random integer in the range [min, max).
 * This is not suitable for any security features, but it's fine for
 * generating the random component of an idempotency key.
 *
 * @param {*} min smallest number in output range, inclusive
 * @param {*} max largest numberr in output range, exclusive
 * @returns an integer in the range [min, max)
 */
function randomNumber(min, max) {
    return Math.floor((Math.random() * (max - min)) + min);
}

function generateIdempotencyKey() {
    const part1 = Date.now(); // timestamp in milliseconds
    const part2 = randomNumber(0, 999);
    return `${part1}.${part2}`;
}

export {
    generateIdempotencyKey,
};
